import http from '@/services/http';
import { leadFormQuery } from '@/type/pages';
import { error } from '@/utils/safetyLog';

export const createLeadForm = async (requestData: leadFormQuery) => {
  try {
    const response = await http({}).post('/salesforce/creatLead', {
      ...requestData,
    });
    return response;
  } catch (e) {
    error('Error creating lead form:', e);
    return null;
  }
};
